import DEBUG from './debug';

const LOG_LEVELS = {
    ALWAYS: -999,
    //ALERT: 1,
    //CRITICAL: 2,
    ERROR: 3,
    WARNING: 4,
    //NOTICE: 5,
    INFO: 6,
    DEBUG: 7,
    //TRACE: 8,
    NONE: 999,
};
const LOG_LEVELS_TO_STRING = {
    '-999': '*INFO',
    '3': 'ERROR',
    '4': 'WARNING',
    '6': 'INFO',
    '7': 'DEBUG',
};

class Logger {

    constructor(level = LOG_LEVELS.WARNING) {
        this.level = level;
    }

    getElapsedTime() {
        let ts = '';
        if (performance && performance.now) {
            ts = (performance.now()/1000).toFixed()+'s';
        }
        return ts;
    }

    log(level, args) {
        if (this.level >= level) {
            const msg = this.decorateLog(args, `[${LOG_LEVELS_TO_STRING[''+level]}][${this.getElapsedTime()}]:`);
            console.log.apply(console, msg);
        }
    }

    decorateLog(args, prefix) {
        args = [].slice.call(args);
        prefix && args.unshift(prefix);
        args.unshift('display: inline-block; color: #fff; background: #3b88c3; padding: 1px 4px; border-radius: 3px;');
        args.unshift('%cRT');
        return args;
    }

    debug(...args) {
        this.log(LOG_LEVELS.DEBUG, args);
    }

    info(...args) {
        this.log(LOG_LEVELS.INFO, args);
    }

    warn(...args) {
        this.log(LOG_LEVELS.WARNING, args);
    }

    error(...args) {
        this.log(LOG_LEVELS.ERROR, args);
    }

    always(...args) {
        this.log(LOG_LEVELS.ALWAYS, args);
    }

}

const instance = new Logger(DEBUG ? LOG_LEVELS.DEBUG : LOG_LEVELS.WARNING);
export default instance;
